module.exports = __webpack_public_path__ + "img/boiler-first.040f59a8.webp";